import { AnyObject, MayNull, PageInfo, PageInput } from '@apeiron/temp'
import * as R from 'ramda'
import { useCallback } from 'react'

const useMakePageInfo = (): Hook => {
  const makePageInfo = useCallback(
    (result: MayNull<AnyObject>, pageInput: PageInput): PageInfo => {
      const pageInfo: any = R.propOr({}, 'pageInfo', result)

      const total = R.propOr(0, 'totalCount', pageInfo) as number

      const pageSize = R.propOr(0, 'pageSize', pageInput) as number

      const totalPage = Math.ceil(total / pageSize)

      return {
        hasNextPage: R.propOr(false, 'hasNextPage', pageInfo),
        hasPreviousPage: R.propOr(false, 'hasPreviousPage', pageInfo),
        total,
        totalPage,
        page: R.propOr(0, 'page', pageInput) as number,
        pageSize,
        previousCursor: R.prop('startCursor', pageInfo),
        nextCursor: R.prop('endCursor', pageInfo)
      }
    },
    []
  )

  return {
    makePageInfo
  }
}

type Hook = {
  makePageInfo: (result: MayNull<AnyObject>, pageInput: PageInput) => PageInfo
}

export default useMakePageInfo
